import React, { useEffect } from 'react';
import * as S from './SimplePageTemplate.styled';
import ContinueButton from '~/shared/components/ContinueButton/ContinueButton';
import aibLogoImg from './assets/aiblogo-flat.svg';
import { hideLoadingSpinner } from '../../../lib/spinnerUtils';

interface Props {
  title?: string;
  onContinue: (...args: unknown[]) => unknown;
  children?: React.ReactNode;
  btnLabel: string;
  btnId: string;
  isMobileApp?: boolean;
  pageLogo?: React.ReactElement;
}

const SimplePageTemplate = ({
  title,
  onContinue,
  children,
  btnLabel,
  btnId,
  isMobileApp,
  pageLogo,
}: Props) => {
  useEffect(hideLoadingSpinner, []);
  return (
    <S.Page>
      <S.PageBody>
        <S.PageHead>
          {pageLogo || <S.PageLogo src={aibLogoImg} />}
          {title && <S.PageTitle>{title}</S.PageTitle>}
        </S.PageHead>

        <S.ContentWrapper>{children}</S.ContentWrapper>
        {!isMobileApp && (
          <ContinueButton
            onClick={onContinue}
            label={btnLabel}
            testId={btnId}
            isEnabled={true}
            continueButtonId={btnId}
          />
        )}
      </S.PageBody>
    </S.Page>
  );
};

// Props validated via TypeScript `Props` interface above

export default SimplePageTemplate;
